import { types, flow, getEnv, Instance } from "mobx-state-tree";

import { endpoints } from "../api/ApiEndpoints";
import { StorageModel } from "../storage/StorageModel";

const ConfidenceLevelModel = types.model({
  name: types.string,
  level: types.number,
});

const AnalysisConfidenceModel = types.model({
  AnalysisLevels: types.optional(types.array(ConfidenceLevelModel), []),
  HighlightLevels: types.optional(types.array(ConfidenceLevelModel), []),
});

export const AnalysisConfidenceStorageModel = types
  .compose(AnalysisConfidenceModel, StorageModel)
  .named("AnalysisConfidenceStorageModel")
  .actions((self) => ({
    mapResponse(response: any) {
      self.AnalysisLevels = response.analysisLevels;
      self.HighlightLevels = response.highlightLevels;
    },
    updateConfidenceLevels: flow(function* (output: any) {
      const endpoint = endpoints.get("analysis_confidence");
      return yield getEnv(self).api.post(endpoint, output);
    }),
  }))
  .views((self) => ({
    get endpoint() {
      return endpoints.get("analysis_confidence");
    },
    get isLoading() {
      return !self.AnalysisLevels.length || !self.HighlightLevels.length;
    },
  }));

export type AnalysisConfidenceStorage = Instance<typeof AnalysisConfidenceStorageModel>;
